export default __webpack_public_path__ + "static/media/img-04.00e62878.jpg";